export default {
  delivered: {
    'link-feedback-popup': {
      title: '저희 서비스를 이용해 주셔서 감사합니다. 귀하의 소중한 의견을 기다립니다.',
      subtitle: 'Google 페이지에 후기를 남겨주세요',
      btn: '확인',
    },
    info: {
      'payment-delivered-title': '배송 완료',
    },
    feedback: {
      title: '귀하의 피드백은 저희에게 중요합니다',
      comment: {
        title: '의견을 남겨주세요:',
        placeholder: '모든 점이 마음에 들었는지, 기대와 인상을 적어주세요',
        'send-btn': '피드백 보내기',
        'change-btn': '피드백 수정',
        'not-send-tooltip': {
          text: '연락 요청',
          title: '고객 서비스에서 연락드립니다',
          content: '피드백을 남겨주시면 고객 서비스 담당자가 곧 연락드릴 것입니다.',
        },
      },
      suggestions: {
        driver: {
          positive: {
            'went-above-and-beyond': '기대 이상으로 서비스 제공',
            'professional-appearance': '전문적인 모습',
            'courteous-and-respectful': '예의 바르고 존중하는 태도',
            'on-time-delivery': '정시 배송',
          },
          negative: {
            'unfriendly-driver': '불친절한 운전사',
            'did-not-follow-instructions': '지시 사항 미준수',
            'late-delivery': '늦은 배송',
            'unprofessional-appearance': '비전문적인 모습',
          },
        },
        dispatcher: {
          positive: {
            'great-communication': '원활한 소통',
            'patient-and-understanding': '인내심 있고 이해심 많음',
            'efficient-coordination': '효율적인 조율',
            'quick-response-time': '빠른 응답 시간',
          },
          negative: {
            'impatient-or-rude': '성급하거나 무례함',
            'poor-coordination': '조율 미흡',
            'failed-to-address-concerns': '문제 해결 실패',
            'slow-response-time': '느린 응답 시간',
          },
        },
        pharmacy: {
          positive: {
            'friendly-staff': '친절한 직원',
            'secure-packaging': '안전한 포장',
            'fast-shipping': '빠른 배송/재고 보충',
            'concise-medication-instructions': '명확한 복약 안내',
          },
          negative: {
            'difficult-to-open': '열기 어려움',
            'incorrect-prescription': '처방 오류',
            'unfriendly-staff': '불친절한 직원',
            'wrong-medication': '잘못된 약품',
          },
        },
      },
    },
  },
  delivering: {
    confirmed: {
      'stops-away': '정거장 남음',
      'your-stop-is-next': '다음 정거장입니다',
      'special-instruction': {
        title: '약국 특별 지시:',
        'new-instruction-input': {
          title: '수취인 특별 지시',
          placeholder: '특별 지시 추가',
        },
        'new-instruction-btn-save': '저장',
        'not-editable-warning': '운전사가 이미 근처에 있어 지시를 변경할 수 없습니다.',
      },
      'arriving-data': {
        today: {
          'label-2': '오늘 도착 예정',
          label: '예상 배송 시간',
        },
        next: {
          label: '운전사가 도착합니다',
          time: '몇 분 내',
        },
        'few-minutes': {
          'label-2': '운전사가 도착합니다',
        },
      },
      qr: {
        info: '운전사에게 QR 코드를 보여주세요',
        description: '주문을 받으려면 운전사에게 QR 코드를 보여주거나 코드를 알려주세요',
        help: '본인 부담금은 보험 계획에 따라 의료 서비스나 처방약에 대해 지불해야 하는 정해진 금액입니다.',
      },
    },
    'confirmed-no-route': {
      title: '배송을 확인했습니다',
      subtitle: '정보를 기다려 주세요',
    },
    'not-confirmed': {
      form: {
        'empty-title': '서명을 꼭 남겨 주세요',
        'pharmacy-instruction-title': '약국 특별 지시:',
        'recipient-instruction': {
          title: '수취인 특별 지시:',
          placeholder: '특별 지시 추가',
          'update-btn': '업데이트',
        },
        sign: {
          description: '운전사가 직접 배달을 시도합니다. 부재 시 문 앞에 두고 사진을 찍습니다.',
          confirm: {
            btn: '배송 확인',
            title: '확실합니까?',
            text: '제공한 정보가 정확함을 확인합니다',
          },
        },
      },
      progress: {
        attempts: '배송 시도:',
        created: '주문 <br> 생성됨',
      },
      transit: '운송 중',
      'out-for-delivery': '배송 중',
      delivered: '배송 완료',
      signature: {
        title: '서명 없이도 택배를 받을 수 있도록 아래에 서명해 주세요:',
        clear: '지우기',
      },
      statuses: {
        'at-pharmacy': '주문이 약국에 있으며 곧 배송됩니다',
        'driver-out': '배송을 확인해 주세요',
        rescheduled: '배송이 재조정되었습니다',
        'pending-back-to-pharmacy': '주문이 약국으로 반송 대기 중입니다',
        'pickup-occured': '주문이 약국에서 수령되어 배송 중입니다',
      },
    },
    rescheduled: {
      attempted: '시도 날짜:',
    },
  },
  investigation: {
    link_start: '문의하려면 ',
    link_end: '로 연락해 주세요',
    instructions: '약국 특별 지시:',
  },
  rescadule: {
    subtitle: '새로운 배송 날짜를 선택해 주세요',
  },
  rejected: {
    'back-to-pharmacy': {
      rejected: '주문이 약국에 의해 취소되었습니다',
      'pending-back-to-pharmacy': '주문이 취소되어 약국으로 반송 대기 중입니다',
      'on-its-way-to-pharmacy': '주문이 취소되어 약국으로 반송이 확인되었습니다',
      default: '주문이 취소되어 약국으로 반송되었습니다',
      'confirmed-back-to-pharmacy': '주문이 취소되어 약국 반송 확인을 기다리는 중입니다',
      'back-to-pharmacy': '주문이 취소되어 약국으로 반송되었습니다',
    },
  },
  returned: {
    'back-to-pharmacy': {
      title: '주문이 약국으로 반송 대기 중입니다',
    },
  },
}
